export default "__VITE_ASSET__423c0176__"